import { NAME } from './constants';
import { router } from './router';

export const ZmenaHesla = {
	name: NAME,
	router,
};
